import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b1fa0d9a&scoped=true&"
import script from "./App.vue?vue&type=script&setup=true&lang=ts&"
export * from "./App.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=b1fa0d9a&prod&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=b1fa0d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fa0d9a",
  null
  
)

export default component.exports